import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { IInstallation } from '../models/installation';

@Injectable({
  providedIn: 'root',
})
export class Installation {
  private baseUrl: string = `${environment.apiUrl}/installation`;
  installations = signal<IInstallation[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  constructor(private http: HttpClient) {}

  getInstallationList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http.get<IInstallation[]>(`${this.baseUrl}/list`).subscribe({
      next: (data) => {
        this.installations.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.log(err);
        this.errorMessage.set('Failed to load installations');
        this.isLoading.set(false);
      },
    });
  }

  updateInstallation(installation: IInstallation) {
    return this.http
      .put<IInstallation>(
        `${this.baseUrl}/update/${installation.id}`,
        installation,
      )
      .pipe(
        tap((updated) => {
          const current = this.installations();
          const index = current.findIndex((i) => i.id === updated.id);
          current[index] = updated;
          this.installations.set([...current]);
        }),
      );
  }

  addInstallation(installation: IInstallation) {
    return this.http.post<IInstallation>(`${this.baseUrl}`, installation).pipe(
      tap((added) => {
        const current = this.installations();
        current.push(added);
        this.installations.set([...current]);
      }),
    );
  }

  deleteInstallation(installation: IInstallation) {
    return this.http.delete(`${this.baseUrl}/${installation.id}`).pipe(
      tap(() => {
        const current = this.installations();
        const index = current.findIndex((i) => i.id === installation.id);
        current.splice(index, 1);
        this.installations.set([...current]);
      }),
    );
  }
}
